import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import 'dayjs/locale/fr';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// dayjs uses 'en' for the en-XA pseudo-locale (it isn't a real locale).
const dayjsLocale = (lang) => (lang === 'en-XA' ? 'en' : (lang || 'en'));

const LocaleSync = ({ children }) => {
    const language = useSelector(state => state.correcttrack.language);
    const { i18n } = useTranslation();

    useEffect(() => {
        if (i18n.language !== language) {
            i18n.changeLanguage(language);
        }
        dayjs.locale(dayjsLocale(language));
    }, [language, i18n]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjsLocale(language)}>
            {children}
        </LocalizationProvider>
    );
};

export default LocaleSync;
